import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  UncontrolledTooltip,
  Table
} from 'reactstrap';
const NumberFormat = require('react-number-format');
const numeral = require('numeral');

class SurveyGridForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: {},
      editingCellId: null,
      focusingInputValueId: null
    }

    this.inputSequence = [];

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
    this.handleOnKeyPressAllowEnter = this.handleOnKeyPressAllowEnter.bind(this);
    this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.renderDataCol = this.renderDataCol.bind(this);

    this._autoCorrect = this._autoCorrect.bind(this);
    this._getColSpan = this._getColSpan.bind(this);
    this._getColumns = this._getColumns.bind(this);
    this._headerNotEmpty = this._headerNotEmpty.bind(this);
    this._isLastColumn = this._isLastColumn.bind(this);
    this._getColByValueId = this._getColByValueId.bind(this);
    this._assignInputRef = this._assignInputRef.bind(this);
  }

  setFormValue(field, value) {
    this.props.setFormValue(field, value);
  }

  saveRowValues(row) {
    let valueIds = row.cols.map((col) => {
      return col.valueId;
    });
    return this.props.saveValues(valueIds);
  }

  renderRowTooltips(row) {
    if (row.instruction ) {
      return (
        <div className="tooltip-icon">
          <a href="#" onClick={(e) => { e.preventDefault() }} id={`row_${row.id}`}>
            <i className="fa fa-question-circle fa-lg text-secondary"></i>
          </a>
          <UncontrolledTooltip placement="right" target={`row_${row.id}`}>
            {row.instruction}
          </UncontrolledTooltip>
        </div>);
    }
  }

  renderDataRow(row) {
    return (
      <tr key={row.id}>
        <td>
          {row.name}
          {this.renderRowTooltips(row)}
          {row.remark && <h6>
            <small className={`text-muted`}>{row.remark}</small>
          </h6>}
        </td>
        {row.cols.map((col, index) => {
          this.inputSequence.push(col.valueId);
          const colSpan = this._getColSpan(row.cols, index);
          return this.renderDataCol(col, colSpan);
        })}
      </tr>
    )
  }

  _getColSpan(rowColumns, index) {
    var groupColumns = this._getColumns();
    if (this._isLastColumn(rowColumns.length, index)) {
      return groupColumns.length - index;
    } else {
      return 1;
    }
  }

  _isLastColumn(numberOfColumns, index) {
    return numberOfColumns <= index + 1;
  }

  renderTextRow(row) {
    var columns = this._getColumns();
    return (
      <tr key={row.id}>
        <td colSpan={columns.length}>
          {row.name}
          {row.remark && <h6>
            <small className={`text-muted`}>
            {row.remark}
            </small>
          </h6>}
        </td>
      </tr>
    );
  }

  renderHeadingRow(row) {
    var columns = this._getColumns();
    return (
      <tr key={row.id}>
        <td colSpan={columns.length}><strong className="font-lg">{row.name}</strong></td>
      </tr>
    )
  }

  toggleEdit(valueId) {
    this.setState({
      editingCellId: valueId,
      focusingInputValueId: valueId
    }, () => {
      if (valueId) {
        this[valueId].focus();
      }
    });
  }

  handleCellClick(col) {
    return function(e) {
      if (this.state.editingCellId !== col.valueId) {
        this.toggleEdit(col.valueId);
      }
    }.bind(this);
  }

  renderDataCol(col, span) {
    let result;
    if (this.state.editingCellId === col.valueId) {
      result = this.renderInput(col);
    } else {
      result = this.renderStatic(col);
    }
    return (
      <td key={col.id} colSpan={span} onClick={this.handleCellClick(col)}>
        {result}
        {col.remark && <h6>
          <small className={`text-muted`}>
            {col.remark}
          </small>
        </h6>}
        {this.renderFormFeedback(this.props.formErrors[col.valueId])}
      </td>
    );
  }

  handleOnChange(e) {
    this.props.setFormValue(e.target.name, e.target.value);
  }

  _getRowByValueId(valueId) {
    return this.props.group.rows.find(row => {
      return row.cols.find(col => col.valueId === valueId);
    });
  }

  _getColByValueId(valueId) {
    return this._getRowByValueId(valueId).cols.find(col => col.valueId === valueId);
  }

  _getErrorCols(cols) {
    return cols.filter(col => this.props.formErrors[col.valueId]);
  }

  handleOnKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleOnBlur(e);
    }
  }

  handleOnKeyPressAllowEnter(e) {
    // if (e.key === 'Enter') {
    //   this.handleOnBlur(e);
    // }
  }

  handleOnKeyDown(e) {
    if (e.key === 'Tab') {
      this.handleOnBlur(e);

      e.preventDefault();
      const index = this.inputSequence.findIndex(value => value === this.state.focusingInputValueId);
      if (this.inputSequence[index+1]) {
        this.toggleEdit(this.inputSequence[index+1]);
      }
    }
  }

  convertToCurrency(value) {
    if ( value ) {
      return numeral(value).format('0,0.00');
    } else {
      return value;
    }
  }

  convertToNumber(value) {
    if ( value ) {
      return numeral(value).value();
    } else {
      return value;
    }
  }

  _autoCorrect(el) {
    const valueId = el.name;
    const oldValue = el.value;
    let newValue = el.value;
    if (this._getColByValueId(valueId).autoCorrect) {
      switch (this._getColByValueId(valueId).autoCorrect) {
        case "ceil":
          newValue = newValue && !isNaN(newValue) ? Math.ceil(newValue) : newValue;
      }
    }
    if (this._getColByValueId(valueId).type === "currency") {
      newValue = this.convertToNumber(newValue);
    }
    if(oldValue !== newValue) {
      this.props.setFormValue(valueId, newValue);
    }
  }

  handleOnBlur(e) {
    const valueId = e.target.name;
    this._autoCorrect(e.target);

    const row = this._getRowByValueId(valueId);
    const valueIds = row.cols.map(col => col.valueId);

    this.props.saveValues(valueIds);
    this.toggleEdit(null);
  }

  renderFormFeedback(messages = []) {
    if (messages.length) {
      return <span>{messages.map((message, index) => { return (<div key={index} className={`text-danger`}>{message}</div>)})}</span>;
    }
  }

  renderStatic(col) {
    var result;
    switch (col.type) {
      case "select":
        result = this.renderSelectStatic(col);
        break;
      case "percentage":
        result = this.props.formValues[col.valueId] ? `${this.props.formValues[col.valueId]}%` : '';
        break;
      case "currency":
        result = this.props.formValues[col.valueId] ? `${numeral(this.props.formValues[col.valueId]).format('$0,0.00')}` : '';
        break;
      case "number":
      case "text":
      case "email":
      case "textarea":
        result = this.props.formValues[col.valueId];
        break;
    }
    return result;
  }

  renderSelectStatic(col) {
    var found = col.options.find(option => option.value === this.props.formValues[col.valueId]);
    if (found) {
      return found.text;
    } else {
      return "[Please select]";
    }
  }

  renderInput(col) {
    var result;
    switch (col.type) {
      case "select":
        result = this.renderSelectInput(col);
        break;
      case "currency":
        result = this.renderCurrencyInput(col);
        break;
      case "number":
        result = this.renderTextInput(col);
        break;
      case "text":
        result = this.renderTextInput(col);
        break;
      case "percentage":
        result = this.renderPercentageInput(col);
        break;
      case "email":
        result = this.renderTextInput(col);
        break;
      case "textarea":
        result = this.renderTextAreaInput(col);
        break;
    }
    return result;
  }

  _assignInputRef(col, ref) {
    this[col.valueId] = ref;
  }

  renderPercentageInput(col) {
    return (
      <Input
        innerRef={(ref) => this._assignInputRef(col, ref)}
        type="text"
        name={col.valueId}
        value={this.props.formValues[col.valueId]}
        placeholder={col.text}
        valid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length <= 0 ? false : null}
        invalid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length > 0 ? true : null}
        disabled={this.props.editable ? null : true}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        onKeyPress={this.handleOnKeyPress}
        onKeyDown={this.handleOnKeyDown}/>
    );
  }

  renderTextAreaInput(col) {
    return (
      <Input
        innerRef={(ref) => this._assignInputRef(col, ref)}
        type="textarea"
        name={col.valueId}
        value={this.props.formValues[col.valueId]}
        placeholder={col.text}
        valid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length <= 0 ? false : null}
        invalid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length > 0 ? true : null}
        disabled={this.props.editable ? null : true}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        onKeyPress={this.handleOnKeyPressAllowEnter}
        onKeyDown={this.handleOnKeyDown}/>
    );
  }

  renderCurrencyInput(col) {
    return (
      <Input
        innerRef={(ref) => this._assignInputRef(col, ref)}
        type="text"
        name={col.valueId}
        value={this.props.formValues[col.valueId]}
        placeholder={col.text}
        valid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length <= 0 ? false : null}
        invalid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length > 0 ? true : null}
        disabled={this.props.editable ? null : true}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        onKeyPress={this.handleOnKeyPress}
        onKeyDown={this.handleOnKeyDown}/>
    );
  }

  renderSelectInput(col) {
    return (
      <Input
        innerRef={(ref) => this._assignInputRef(col, ref)}
        type="select"
        name={col.valueId}
        value={this.props.formValues[col.valueId]}
        placeholder={col.text}
        valid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length <= 0 ? false : null}
        invalid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length > 0 ? true : null}
        disabled={this.props.editable ? null : true}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        onKeyPress={this.handleOnKeyPress}
        onKeyDown={this.handleOnKeyDown}>
        <option>Please select</option>
        {col.options.map((option, index) => {
          return (
            <option key={index} value={option.value}>{option.text}</option>
          )
        })}
      </Input>
    );
  }

  renderTextInput(col) {
    return (
      <Input
        innerRef={(ref) => this._assignInputRef(col, ref)}
        type="text"
        name={col.valueId}
        value={this.props.formValues[col.valueId]}
        placeholder={col.text}
        valid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length <= 0 ? false : null}
        invalid={this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length > 0 ? true : null}
        disabled={this.props.editable ? null : true}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        onKeyPress={this.handleOnKeyPress}
        onKeyDown={this.handleOnKeyDown}/>
    );
  }

  renderTableRow(row) {
    if ( row.type === 'data' ) {
      return this.renderDataRow(row);
    } else if ( row.type === 'text' ) {
      return this.renderTextRow(row);
    } else if ( row.type === 'heading' ) {
      return this.renderHeadingRow(row);
    }
  }

  renderTableBody() {
    return (<tbody>{this.props.group.rows.map((row, index) => this.renderTableRow(row))}</tbody>);
  }

  _getColumns() {
    const highestRow = this.props.group.rows.reduce((result, cur) => {
      return result.cols.length > cur.cols.length ? result : cur;
    });
    const columns = highestRow.cols.map(col => col.text || "");
    columns.unshift("");
    return columns; // Unshift label header to list
  }

  _headerNotEmpty() {
    return this._getColumns().filter((column) => column !== "").length > 0;
  }

  renderTableHead() {
    var columns = this._getColumns();
    if (this._headerNotEmpty()) {
      return (
        <thead>
          <tr>
            {columns.map((column, indx) => <th key={indx}>{column}</th>)}
          </tr>
        </thead>
      );
    }
  }

  render() {
    return (
      <div className={`grid-form-container`}>
        <Table className={`grid-form`} bordered>
          {this.renderTableHead()}
          {this.renderTableBody()}
        </Table>
      </div>
    );
  }
}

SurveyGridForm.defaultProps = {
  editable: true
}

SurveyGridForm.propTypes = {
  setFormValue: PropTypes.func.isRequired,
  saveValues: PropTypes.func.isRequired,
  formValues: PropTypes.object.isRequired,
  formErrors: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  editable: PropTypes.bool
}

export default SurveyGridForm;



// WEBPACK FOOTER //
// ./src/components/SurveyView/SurveyForm/SurveyGridForm.js